import { Injectable } from '@angular/core';

@Injectable()
export class WidgetQueryFilterService {

  constructor() { }

  queryFilter(array, filter) {
    const itemFilter = function (iFilter, item) {
      if (iFilter instanceof Function) {
        return iFilter(item);
      } else if (iFilter instanceof Array) {
        for (let k = 0; k < iFilter.length; ++k) {
          if (itemFilter(iFilter[k], item)) {
            return true;
          }
        }
        return false;
      } else if ((item === item + 0 || typeof (item) === 'string') && iFilter
        && (iFilter.LT || iFilter.GT || iFilter.LE
          || iFilter.GE || iFilter.NE || iFilter.EQ)) {
        // item is number and filter contains min-max
        return ((!('LT' in iFilter) || item < iFilter.LT)
          && (!('GT' in iFilter) || item > iFilter.GT)
          && (!('LE' in iFilter) || item <= iFilter.LE)
          && (!('GE' in iFilter) || item >= iFilter.GE)
          && (!('EQ' in iFilter) || item === iFilter.EQ)
          && (!('NE' in iFilter) || item !== iFilter.NE));
      } else if (item && item.constructor === Array && iFilter.CONTAINS) {
        // item is array and filter has contains attribute

        const matches = item.filter((element) => {
          return element === iFilter.CONTAINS;
        });
        return matches.length > 0;
      } else if (typeof (iFilter) === 'object') {
        for (const key in iFilter) {
          if (!itemFilter(iFilter[key], item[key])) {
            return false;
          }
        }
        return true;
      }
      return (iFilter === item);
    };
    const filtered = [];
    for (let k = 0; k < array.length; ++k) {
      if (itemFilter(filter, array[k])) {
        filtered.push(array[k]);
      }
    }
    return filtered;
  }
}



// WEBPACK FOOTER //
// ./app/widgets/widgetDisplayQueries/widget-query-filter.service.ts